
import { Injectable } from "@angular/core";
import { ImagePicker, ImagePickerOptions } from '@ionic-native/image-picker';

@Injectable()
export class ImagePickerNative {

    constructor(
        private imagePicker: ImagePicker,
    ) {

    }

    getPictures(options: ImagePickerOptions) {
        return this.imagePicker.getPictures(options);
    }

    async hasReadPermission() {
        return await this.imagePicker.hasReadPermission();
    }

    async requestReadPermission() {
        return await this.imagePicker.requestReadPermission();
    }

}


// WEBPACK FOOTER //
// ./src/native/image-picker.native.ts